
export class MachineDefect {
    id: number;
    defect: string;
    description: string;
    outOfOrderFlag: boolean;
    archivedDate?: Date;

    constructor (
        id:number,
        defect: string,
        description: string,
        outOfOrderFlag: boolean,
        archivedDate?: Date
    ) {
        this.id = id;
        this.defect = defect;
        this.description = description;
        this.outOfOrderFlag = outOfOrderFlag;
        this.archivedDate = archivedDate;
    }
    static empty(): MachineDefect {
        return {
            id: 0,
            defect: '',
            description: '',
            outOfOrderFlag: false,
        };
    }

}